// src/App.js

import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/footer/Footer";

/* HOME PAGE COMPONENTS */
import ScrollToTop from "./components/ScrollToTop";
import Cover from "./components/Cover/Cover";
import About from "./components/About/About";
import Benefits from "./components/Benfits/Benfit";
import WhyChoose from "./components/Whychooseus/Whychooseus";
import AddOnServices from "./components/AddonServices/AddonServices";
import Appointment from "./components/Appointment/Appointment";
import Reviews from "./components/Review/Review";

/* INNER PAGE */
import AboutPage from "./pages/About/About";
import Services from "./pages/Services/Services"
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import Credits from "./pages/PrivacyPolicy/Credits/Credits";

function HomePage() {
  return (
    <>
      <Cover />
      <About />
      <Benefits />
      <WhyChoose />
      <AddOnServices />
      <Appointment />
      <Reviews />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
<ScrollToTop />
      <Navbar />

      <Routes>

        {/* HOME PAGE */}
        <Route
          path="/"
          element={<HomePage />}
        />

        {/* ABOUT PAGE */}
        <Route
          path="/about"
          element={<AboutPage />}
        />
        <Route
          path="/services"
          element={<Services />}
        />
        <Route
          path="/appointment"
          element={<Appointment />}
        />
        <Route
          path="/privacy"
          element={<PrivacyPolicy />}
        />
        <Route
        path = "/credits"
        element = {<Credits/>}
        />
      

      </Routes>

      <Footer />

    </BrowserRouter>
  );
}

export default App;